import { useQuery } from "@tanstack/react-query";
import { api, type ResourceResponse } from "@shared/api/client";
import type { BillingDashboard } from "../types/dashboard";

export const dashboardKeys = {
  all: ["billing-dashboard"] as const,
};

export function useBillingDashboard() {
  return useQuery({
    queryKey: dashboardKeys.all,
    queryFn: async () => {
      const { data } =
        await api.get<ResourceResponse<BillingDashboard>>("/billing/dashboard");
      return data.data;
    },
    staleTime: 60_000, // 1 min
  });
}
